$.events = {
	ticket: {
		participant: {
			callback: {
				getAll: {
					success: function(data) {
						$.each(data.content, function(index, value) {
							$(document.createElement('tr'))
							.append(
								$(document.createElement('td'))
								.html(value.Id)
							)
							.append(
								$(document.createElement('td'))
								.html(value.TicketTitle)
							)
							.append(
								$(document.createElement('td'))
								.html(value.TicketType)
							)
							.append(
								$(document.createElement('td'))
								.html(value.DynamicField1)
							)
							.append(
								$(document.createElement('td'))
								.html(value.CustomerName +'<br />'+ value.CustomerEmail +'<br />'+ value.CustomerPhone)
							)
							.append(
								$(document.createElement('td'))
								.html(value.CustomerBirthday)
							)
							.append(
								$(document.createElement('td'))
								.addClass('text-right')
								.html(value.Added)
							)
							.append(
								$(document.createElement('td'))
								.addClass('text-right')
								.html(value.Used)
							)
							.append(
								$(document.createElement('td'))
								.addClass('text-right')
								.html(value.TicketPrice)
							)
							.appendTo('#contentList');
						});
					},
					error: function(data) {
						$(document.createElement('tr'))
						.append(
							$(document.createElement('td'))
							.attr({
								'colspan' : '8'
							})
							.html(data.error.msg)
						)
						.appendTo('#contentList');
					}
				}
			},

			pull: {
				getAll: function() {
					$('#dialogToolbar').ajax_callback('/json/event/view/guestlist/getAll', {
						'eventId' : $('#tmpEventId').val()
					}, {
						alertToolbar: true,
						callback_success: $.events.ticket.participant.callback.getAll.success,
						callback_error: $.events.ticket.participant.callback.getAll.error
					});
				}
			}
		},

		scanning: {
			callback: {
				scan: {
					success: function(data) {
						$('#tmpScanField').val($('#ticketId').val());
						$('#contentBlockScanning').empty();

						if(data.respons.type == 'ticket') {
							$('#ticketId').val('').removeClass('warning').addClass('success').focus();
						} else if(data.respons.type == 'cpr') {
							$('#ticketId').val('').removeClass('warning success').focus();

							if(data.tmpTicketId != '') {
								$('#tmpTicketId').val(data.tmpTicketId);
							}

							var contentObj = $(document.createElement('tbody'));

							$.each(data.tickets, function(index, value) {
								if(value.Used == '1000-01-01 00:00:00') {
									var usedBlock = $(document.createElement('button'))
									.addClass('btn btn-xs btn-primary')
									.attr({
										'onclick' : '$.events.ticket.scanning.push.useTicket(' + value.Id + ')'
									})
									.html('Benyt billet');
								} else {
									var usedBlock = '';
								}

								contentObj.append(
									$(document.createElement('tr'))
									.addClass(($('#tmpTicketId').val() == value.Id ? 'success' : (usedBlock == '' ? 'warning' : '')))
									.append(
										$(document.createElement('td'))
										.html(value.Name)
									)
									.append(
										$(document.createElement('td'))
										.html(value.DynamicField)
									)
									.append(
										$(document.createElement('td'))
										.html(value.Birthday)
									)
									.append(
										$(document.createElement('td'))
										.html(value.TicketType)
									)
									.append(
										$(document.createElement('td'))
										.html(value.Used)
									)
									.append(
										$(document.createElement('td'))
										.addClass('text-right')
										.html(usedBlock)
									)
								)
							});

							$(document.createElement('div'))
							.addClass('box box-default')
							.append(
								$(document.createElement('div'))
								.addClass('box-body')
								.attr({
									'id' : 'contentBlockList'
								})
								.append(
									$(document.createElement('table'))
									.addClass('table table-striped table-bordered table-hover')
									.append(
										$(document.createElement('thead'))
										.append(
											$(document.createElement('tr'))
											.append(
												$(document.createElement('th'))
												.html('Deltager navn')
											)
											.append(
												$(document.createElement('th'))
												.html('Dynamisk felt')
											)
											.append(
												$(document.createElement('th'))
												.html('Fødselsdag')
											)
											.append(
												$(document.createElement('th'))
												.html('Billet type')
											)
											.append(
												$(document.createElement('th'))
												.html('Billet benyttet')
											)
											.append(
												$(document.createElement('th'))
												.html('&nbsp;')
											)
										)
									)
									.append(contentObj)
								)
							)
							.appendTo('#contentBlockScanning');

							$('#tmpTicketId').val('');
						}
					},
					error: function(data) {
						// CP00001925ED
						if(data.status == '301') {
							$('#ticketId').val('').removeClass('success').addClass('warning').focus();
						} else {
							$('#ticketId').val('').removeClass('warning success').focus();
							$('#contentBlockScanning').html('');
						}
					}
				},

				useTicket: {
					success: function(data) {
						$('#ticketId').val($('#tmpScanField').val());
						$.events.ticket.scanning.push.scan();
					}
				}
			},

			push: {
				scan: function() {
					$('#dialogToolbar').ajax_callback('/json/event/view/scanning/scan', {
						'eventId' : $('#tmpEventId').val(),
						'ticketId' : $('#ticketId').val(),
					}, {
						alertToolbar: true,
						callback_success: $.events.ticket.scanning.callback.scan.success,
						callback_error: $.events.ticket.scanning.callback.scan.error
					});
				},

				useTicket: function(ticketId) {
					$('#tmpTicketId').val(ticketId);

					$('#dialogToolbar').ajax_callback('/json/event/view/scanning/useTicket', {
						'eventId' : $('#tmpEventId').val(),
						'ticketId' : ticketId,
					}, {
						alertToolbar: true,
						callback_success: $.events.ticket.scanning.callback.useTicket.success
					});
				}
			}
		},

		callback: {
			getAll: {
				success: function(data) {
					$('#contentList').empty();

					$.each(data.content, function(index, value) {
						$(document.createElement('tr'))
						.append(
							$(document.createElement('td'))
							.html(value.Type)
						)
						.append(
							$(document.createElement('td'))
							.html(value.Start)
						)
						.append(
							$(document.createElement('td'))
							.html(value.End)
						)
						.append(
							$(document.createElement('td'))
							.addClass('text-right')
							.html(value.Amount)
						)
						.append(
							$(document.createElement('td'))
							.addClass('text-right')
							.html(value.Sold)
						)
						.append(
							$(document.createElement('td'))
							.addClass('text-right')
							.html(value.AmountBack)
						)
						.append(
							$(document.createElement('td'))
							.addClass('text-right')
							.html(value.Price)
						)
						.append(
							$(document.createElement('td'))
							.addClass('text-right')
							.append(
								$(document.createElement('button'))
								.addClass('btn btn-xs btn-default')
								.attr({
									'onclick' : '$.events.ticket.push.activated(' + (value.Activated == 1 ? 0 : 1) + ', ' + value.Id + ')',
									'data-toggle' : 'tooltip',
									'title' : (value.Activated == 1 ? 'Deaktiver' : 'Aktiver')
								})
								.append(
									$(document.createElement('i'))
									.addClass('fa ' + (value.Activated == 1 ? 'fa-eye' : 'fa-eye-slash'))
								)
							)
							.append(' ')
							.append(
								$(document.createElement('a'))
								.addClass('btn btn-xs btn-success')
								.attr({
									'href' : '/action/event/ticket/update/' + value.Id,
									'data-toggle' : 'modal',
									'title' : 'Redigere billet type',
									'data-target' : '#modalDialog'
								})
								.append(
									$(document.createElement('i'))
									.addClass('fa fa-pencil')
								)
							)
						)
						.appendTo('#contentList');
					});

					onDocumentStart();
				},
				error: function(data) {
					$('#contentList').empty();
					$(document.createElement('tr'))
					.append(
						$(document.createElement('td'))
						.attr({
							'colspan' : '6'
						})
						.html(data.error.msg)
					)
					.appendTo('#contentList');
				}
			},

			create: {
				success: function(data) {
					$('#modalDialog').modal('hide');
					$.events.ticket.pull.getAll();
				}
			},

			update: {
				success: function(data) {
					$('#modalDialog').modal('hide');
					$.events.ticket.pull.getAll();
				}
			},

			activated: {
				success: function(data) {
					$.events.ticket.pull.getAll();
				}
			}
		},

		push: {
			create: function() {
				$('#dialogToolbarAlert').ajax_callback('/json/event/ticket/create', {
					'eventId' : $('#eventId').val(),
					'type' : $('#ticketType').val(),
					'price' : $('#ticketPrice').val(),
					'amount' : $('#ticketAmount').val(),
					'dateStart' : $('#ticketDateStart').val(),
					'dateEnd' : $('#ticketDateEnd').val(),
				}, {
					alertToolbar: true,
					callback_success: $.events.ticket.callback.create.success
				});
			},

			update: function() {
				$('#dialogToolbarAlert').ajax_callback('/json/event/ticket/update', {
					'ticketId' : $('#ticketId').val(),
					'amount' : $('#ticketAmount').val(),
					'dateStart' : $('#ticketDateStart').val(),
					'dateEnd' : $('#ticketDateEnd').val()
				}, {
					alertToolbar: true,
					callback_success: $.events.ticket.callback.update.success
				});
			},

			activated: function(activated, ticketId) {
				$('#dialogToolbar').ajax_callback('/json/event/ticket/activated', {
					'activated' : activated,
					'ticketId' : ticketId
				}, {
					alertToolbar: false,
					callback_success: $.events.ticket.callback.activated.success
				});
			}
		},

		pull: {
			getAll: function() {
				$('#dialogToolbar').ajax_callback('/json/event/ticket/getAll', {
					'eventId' : $('#eventId').val()
				}, {
					alertToolbar: false,
					callback_success: $.events.ticket.callback.getAll.success,
					callback_error: $.events.ticket.callback.getAll.error
				});
			}
		}
	},

	update: {
		callback: {
			settingsContact: {
				success: function(data) {
					location.reload();
				}
			},

			settingsEvent: {
				success: function(data) {
					location.reload();
				}
			},
		},

		push: {
			settingsContact: function(eventId) {
				$('#dialogToolbarAlert').ajax_callback('/json/event/update/contactSettings', {
					'eventId' : eventId,
					'eventOrganizer' : $('#eventOrganizer').val(),
					'eventEmail' : $('#eventEmail').val(),
					'eventLocation' : $('#eventLocation').val(),
					'eventStreet' : $('#eventStreet').val(),
					'eventZipcode' : $('#eventZipcode').val(),
					'eventCity' : $('#eventCity').val()
				}, {
					alertToolbar: true,
					callback_success: $.events.update.callback.settingsContact.success
				});
			},

			settingsEvent: function(eventId) {
				$('#dialogToolbarAlert').ajax_callback('/json/event/update/eventSettings', {
					'eventId' : eventId,
					'eventTitle' : $('#eventTitle').val(),
					'dynamicField1' : $('#dynamicField1').val(),
					'eventStart' : $('#eventStart').val(),
					'eventEnd' : $('#eventEnd').val(),
					'allowDoorSales' : $('#allowTicketDoorSales:checked').val(),
				}, {
					alertToolbar: true,
					callback_success: $.events.update.callback.settingsEvent.success
				});
			},

			description: function(eventId) {
				$('#dialogToolbarAlert').ajax_callback('/json/event/update/description', {
					'eventId' : eventId,
					'eventDescription' : CKEDITOR.instances['eventDescription'].getData()
				}, {
					alertToolbar: true
				});
			}
		}
	},

	callback: {
		getAll: {
			success: function(data) {
				$('#eventList').empty();

				$(document.createElement('div'))
				.addClass('box')
				.append(
					$(document.createElement('div'))
					.addClass('box-body')
					.append(
						$(document.createElement('a'))
						.addClass('btn btn-success btn-flat')
						.attr({
							'href' : '/event/create'
						})
						.append(
							$(document.createElement('i'))
							.addClass('fa fa-ticket')
						)
						.append(' Tilføj nyt event')
					)
					.append($(document.createElement('hr')))
					.append(
						$(document.createElement('table'))
						.addClass('table table-hover table-striped')
						.append(
							$(document.createElement('thead'))
							.append(
								$(document.createElement('tr'))
								.append(
									$(document.createElement('th'))
									.html('Titel på event')
								)
								.append(
									$(document.createElement('th'))
									.html('Dørene åbner')
								)
								.append(
									$(document.createElement('th'))
									.html('Dørene lukker')
								)
								.append(
									$(document.createElement('th'))
									.addClass('text-right')
									.html('Solgte billetter')
								)
								.append(
									$(document.createElement('th'))
									.addClass('text-right')
									.html('Brugte billetter')
								)
								.append(
									$(document.createElement('th'))
									.html('&nbsp;')
								)
							)
						)
						.append(
							$(document.createElement('tbody'))
							.attr({
								'id' : 'contentList'
							})
						)
					)
				)
				.appendTo('#eventList');


				$.each(data.content, function(index, value) {
					$(document.createElement('tr'))
					.append(
						$(document.createElement('td'))
						.html(value.Title)
					)
					.append(
						$(document.createElement('td'))
						.html(value.Start)
					)
					.append(
						$(document.createElement('td'))
						.html(value.End)
					)
					.append(
						$(document.createElement('td'))
						.addClass('text-right')
						.html(value.TicketSales)
					)
					.append(
						$(document.createElement('td'))
						.addClass('text-right')
						.html(value.TicketUsed)
					)
					.append(
						$(document.createElement('td'))
						.addClass('text-right')
						.append(
							$(document.createElement('a'))
							.attr({
								'href' : '/event/view/'+ value.EventId
							})
							.addClass('btn btn-xs btn-default')
							.append(
								$(document.createElement('i'))
								.addClass('fa fa-pencil')
							)
						)
					)
					.appendTo('#contentList');
				});
			},
			error: function(data) {
				$('#eventList').empty();

				$(document.createElement('div'))
				.attr({
					'align' : 'center'
				})
				.append(
					$(document.createElement('i'))
					.addClass('fa fa-ticket')
					.attr({
						'style' : 'font-size: 240px;'
					})
				)
				.append(
					$(document.createElement('br'))
				)
				.append(
					$(document.createElement('br'))
				)
				.append(
					$(document.createElement('a'))
					.attr({
						'href' : '/event/create'
					})
					.addClass('btn btn-lg btn-success')
					.html(data.lang.btn.create)
				)
				.appendTo('#eventList');
			}
		},

		create: {
			success: function(data) {
				location.href = '/event/view/'+ data.eventId
			}
		}
	},

	push: {
		create: function() {
			var ticketAvailable = [];
			var i = 0;

			$('.ticketAvailable:checked').each(function () {
				ticketAvailable[i] = this.value;
				i++;
			});

			$('#dialogToolbar').ajax_callback('/json/event/create', {
				'eventTitle' : $('#eventTitle').val(),
				'eventOrganizer' : $('#eventOrganizer').val(),
				'eventEmail' : $('#eventEmail').val(),
				'eventLocation' : $('#eventLocation').val(),
				'eventStreet' : $('#eventStreet').val(),
				'eventZipcode' : $('#eventZipcode').val(),
				'eventCity' : $('#eventCity').val(),
				'eventStart' : $('#eventStart').val(),
				'eventEnd' : $('#eventEnd').val(),
				'eventDescription' : CKEDITOR.instances['eventDescription'].getData(),
				'eventTicketAvailable' : ticketAvailable,
				'dynamicField1' : $('#dynamicField1').val(),
				'mobilepay' : $('#mobilepay:checked').val()
			}, {
				alertToolbar: true,
				callback_success: $.events.callback.create.success
			});
		}
	},

	pull: {
		getAll: function() {
			$('#dialogToolbar').ajax_callback('/json/event/getAll', {
			}, {
				alertToolbar: true,
				callback_success: $.events.callback.getAll.success,
				callback_error: $.events.callback.getAll.error
			});
		}
	}
};
